export class Web {
  idWeb: number;
  tituloProyectoWeb: string;
  descripcionWeb: string;
  web: string;
  empresaWeb: string;
  fechaWeb: string;
  imagenWeb: string;
  imagenWeb2: string;
  imagenWeb3: string;
  imagenWeb4: string;
  imagenWeb5: string;
  tituloDetalleWeb: string;
  descripcionDetalleWeb: string;
  porcentajeFigma: string;
  porcentajeHtmlyCss: string;
  porcentajeBootstrap: string;
  porcentajeWordpress: string;
  porcentajePhotoshop: string;
}
